import lightGallery from "lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
const galleryArray = document.querySelectorAll('.js-article-image-anotation');

galleryArray.forEach((element) => {
  lightGallery(element, {
    speed: 500,
    selector: ".js-lightbox",
    plugins: [lgZoom],
    licenseKey: '8C1D605B-6C6F4022-9AE1B332-5383DA54'
  });
});
